module.exports = __webpack_public_path__ + "static/hvhh-3-d24b65971f1da003f7ec2a98893d32ce.png";